import { Injectable } from "@angular/core";
import { DatePipe } from '@angular/common';

@Injectable()
export class DatePipeService {

    constructor(private datePipe: DatePipe) {
    }

    public convertDateToUTC(date: Date) {
        var newUTCDate = date;
        return new Date(this.datePipe.transform(newUTCDate, 'MM/dd/yyyy HH:mm') + ' UTC');
    }

    public convertDateTimeToUTC(date: Date, time: Date) {
        var newUTCDate = date;
        newUTCDate.setHours(new Date(time).getHours());
        newUTCDate.setMinutes(new Date(time).getMinutes());
        return new Date(this.datePipe.transform(newUTCDate, 'MM/dd/yyyy HH:mm') + ' UTC');
    }

    public transformDate(date: any) {
        return this.datePipe.transform(new Date(date), "dd MMM yyyy");
    }

    public getRangeCurrentMonth() {
        const date = new Date();

        return [
            new Date(date.getFullYear(), date.getMonth(), 1),
            new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59)
        ];
    }

    public getRangeCurrentWeek() {
        const date = new Date();
        var weekstart = date.getDate() - date.getDay() + 1;
        var weekend = weekstart + 6;       // end day is the first day + 6 
        var monday = new Date(date.setDate(weekstart));
        monday.setHours(0);
        monday.setMinutes(0);
        monday.setSeconds(0);
        var sunday = new Date(date.setDate(weekend));
        sunday.setHours(23);
        sunday.setMinutes(59);
        sunday.setSeconds(59);

        return [monday, sunday]
    }

    public convertTime(time: string, format: string): string {
        const [hours, minutes] = time.split(':').map(Number);
        const date = new Date();
        date.setHours(hours, minutes);
        return this.datePipe.transform(date, format)!;
    }

    public convertDateTime(date: any, format: string) {
        return this.datePipe.transform(new Date(date), format);
    }

    public formatDateRange(date: string): string {
        const dateObj = new Date(date);
        const year = dateObj.getFullYear();
        const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
        const day = dateObj.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
}